import {
  defaultRubberDuckRoundListFilter,
  rubberDuckRoundListColumnVisibilityOptions,
  defaultRubberDuckRoundListColumnVisibility,
} from '@utils/tables/rounds/rubberDuckRoundListFilter';

// System
import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  limit: 25,
  page: 1,
  total: 0,
  selectedFilters: defaultRubberDuckRoundListFilter,
  columnVisibility: defaultRubberDuckRoundListColumnVisibility,
  columnVisibilityOptions: rubberDuckRoundListColumnVisibilityOptions,
  roundTableFilters: {},
  currentRoundConfig: {},
};

const rubberDuckRoundTableSlice = createSlice({
  name: 'rubberDuckRoundTable',
  initialState,
  reducers: {
    setLimit: (state, { payload }) => {
      state.limit = payload;
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setTotal: (state, { payload }) => {
      state.total = payload;
    },
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
    setRoundTableFilters: (state, { payload }) => {
      const { codeName, value } = payload;
      const { roundTableFilters } = state;

      const newRoundTableFilters = { ...roundTableFilters, [codeName]: value };
      state.roundTableFilters = newRoundTableFilters;
    },
    setClearRoundTableFilters: (state) => {
      state.roundTableFilters = {};
    },
    setCurrentRoundConfig: (state, { payload }) => {
      state.currentRoundConfig = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: rubberDuckRoundTableReducer } = rubberDuckRoundTableSlice;
export const {
  setColumnVisibility,
  setLimit,
  setTotal,
  setPage,
  setRoundTableFilters,
  setCurrentRoundConfig,
  setClearRoundTableFilters,
} = rubberDuckRoundTableSlice.actions;
